<template>
    <v-frontend>
        <v-wrapper element="main">
            <template v-if="load">
                <v-loader border="4" class="property__loader" size="40" />
            </template>
            <template v-else>
                <template v-if="property.error !== undefined">
                    <h1>Lo sentimos ocurrió un error: {{ property.error }}</h1>
                </template>
                <template v-else>
                    <v-grid template="right">
                        <v-box element="section">
                            <template>
                                <v-go-back />
                            </template>
                            <div class="property__header">
                                <h2>{{ property.title }}</h2>
                                <h1>
                                    <b>{{ property.currency }} {{ property.price }}</b>
                                </h1>
                            </div>
                            <div class="tab" v-if="property.videos.length > 0">
                                <button class="tablinks active" @click="changeTab($event, 'imagenes')">Imagenes</button>
                                <button class="tablinks" @click="changeTab($event, 'videos')">Videos</button>
                            </div>
                            <div id="imagenes" ref="imagenes" class="tabcontent active">
                                <v-slider :images="property.images" :title="property.title" />
                            </div>
                            <div id="videos" ref="videos" class="tabcontent" v-if="property.videos.length > 0">
                                <v-slider-videos :videos="property.videos" :title="property.title" />
                            </div>
                            <div class="property__information">
                                <div class="property__head">
                                    <h3 class="property__head__title">{{ titleProperty(property) }}</h3>
                                    <!-- <h3 class="property__head__title">{{ operation(property.operation) }} de {{ type(property.type) }}</h3> -->
                                    <h1 class="property__head__price">{{ property.currency }} {{ property.price }}</h1>
                                </div>

                                <div class="property__detail property__detail--size">
                                    <span v-if="property.operation !== undefined">
                                        <b>Tipo de operación:</b>
                                        {{ operation(property.operation) }}
                                    </span>
                                    <span v-if="property.code !== undefined">
                                        <b>Código:</b>
                                        {{ property.code }}
                                    </span>
                                    <span v-if="property.address !== undefined">
                                        <b>Dirección:</b>
                                        {{ property.address }}
                                    </span>
                                    <span v-if="property.zipCode !== undefined">
                                        <b>Còdigo postal:</b>
                                        {{ property.zipCode }}
                                    </span>
                                    <span v-if="property.branch.zone2Description !== undefined">
                                        <b>Ubicación:</b>
                                        {{ property.zone0Desc }}, {{ property.zone1Desc }}, {{ property.zone2Desc }}
                                    </span>
                                    <span v-if="property.price !== undefined">
                                        Precio: <b>{{ property.currency }} {{ property.price }}</b>
                                    </span>
                                    <span v-if="property.paymentPeriod !== undefined">
                                        <b>Período de pago:</b>
                                        {{ property.paymentPeriod }}
                                    </span>
                                    <span v-if="property.occupancy !== undefined">
                                        <b>Ocupación máxima:</b>
                                        {{ property.occupancy }}
                                    </span>
                                    <span v-if="property.expenses !== undefined">
                                        <b>Expensas:</b>
                                        {{ property.expensesCurrency }} {{ property.expenses }}
                                    </span>
                                    <span v-if="property.taxes !== undefined">
                                        <b>Impuestos:</b>
                                        {{ property.taxesCurrency }} {{ property.taxes }}
                                    </span>
                                    <span v-if="property.mortgageReady !== undefined">
                                        <b>Apto crédito:</b>
                                        {{ property.mortgageReady }}
                                    </span>
                                    <span class="span-2" v-if="property.conditions !== undefined">
                                        <b>Condiciones:</b>
                                        {{ property.conditions }}
                                    </span>
                                </div>
                                <!-- <h3 v-if="location.boolean">Ubicación</h3>
                            <div class="property__detail" v-if="location.boolean">
                                <template v-for="(out, inx) in location.data">
                                    <span :key="inx" v-if="out.value !== undefined">
                                        <b>{{ out.name }}:</b>
                                        {{ out.value }}
                                    </span>
                                </template>
                                </div>-->
                                <h3 v-if="features.boolean">Características</h3>
                                <div class="property__detail">
                                    <span>
                                        <b>Tipo de inmueble:</b>
                                        {{ type(property.type) }}
                                    </span>
                                    <span v-if="property.expensesPrice !== undefined">
                                        <b>Expensas:</b>
                                        {{ property.expensesCurrency }} {{ property.expensesPrice }}
                                    </span>
                                    <template v-for="(out, inx) in features.data">
                                        <span :key="inx" v-if="out.value !== undefined">
                                            <b>{{ out.name }}:</b>
                                            {{ out.value }}
                                        </span>
                                    </template>
                                </div>
                                <h3 v-if="surfaces.boolean">Superficie</h3>
                                <div class="property__detail" v-if="surfaces.boolean">
                                    <template v-for="(out, inx) in surfaces.data">
                                        <span :key="inx" v-if="out.value !== undefined">
                                            <b>{{ out.name }}:</b>
                                            {{ out.value }}
                                        </span>
                                    </template>
                                </div>
                                <h3>{{ customer }}</h3>
                                <div class="property__actions">
                                    <button
                                        @click="$store.commit('modals/modalHandler', { name: 'modalContact', boolean: true })"
                                        type="button"
                                    >
                                        <v-icon name="send" />
                                        <span>Enviar mensaje</span>
                                    </button>
                                    <button
                                        @click="
                                            $store.commit('modals/modalHandler', {
                                                name: 'modalContactAddress',
                                                boolean: true,
                                                property: property.branch,
                                            })
                                        "
                                        type="button"
                                    >
                                        <span>Ver Información del Vendedor</span>
                                    </button>
                                </div>
                                <h3>Descripción</h3>
                                <p>{{ property.description }}</p>
                            </div>
                            <v-map :lat="property.location.lat" :lon="property.location.lon" v-if="property.location !== undefined" />
                        </v-box>
                        <aside class="property__aside">
                            <v-box element="div" padding>
                                <div class="property__customer">
                                    <h3>{{ property.customerName }}</h3>

                                    <img :alt="property.customerName" :src="property.customerLogo" />
                                </div>
                                <button
                                    @click="$store.commit('modals/modalHandler', { name: 'modalContact', boolean: true })"
                                    class="button button--blue"
                                    type="button"
                                >
                                    Contactar
                                </button>

                                <button
                                    @click="$store.commit('modals/modalHandler', { name: 'modalContactMe', boolean: true })"
                                    type="button"
                                >
                                    <v-icon name="call" />
                                    <span>Quiero que me llamen</span>
                                </button>
                            </v-box>
                            <v-properties
                                :exclude="property.code"
                                :operation="property.operation"
                                :zone1="property.zone1"
                                :zone2="property.zone2"
                                :zone3="property.zone3"
                            />
                            <v-histories />
                        </aside>
                    </v-grid>
                    <button
                        v-if="property.branch.mobile"
                        class="property__whatsapp"
                        @click="
                            $store.commit('modals/modalHandler', { name: 'modalContactWhatsApp', boolean: true, property: property.branch })
                        "
                        type="button"
                    >
                        <img class="property__whatsapp__icon" src="/img/whatsapp.svg" />
                    </button>
                </template>
            </template>
        </v-wrapper>
        <template v-if="!load">
            <v-contact :data="property" />
            <v-contact-address :data="property" />
            <v-contact-whatsapp :data="property" />
        </template>
        <!-- <pre>{{ property }}</pre> -->
    </v-frontend>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

import operationNames from '../helpers/operationNames'

import { properties, property } from '@/services/ApiMapaprop'
import { propertyHit } from '@/services/propertyApi'

import vSlider from '@/components/vSlider'

export default {
  metaInfo() {
    return {
      property: true,
      metaTags: [
        {
          property: 'og:url',
          content: this.$route.path
        },
        {
          property: 'article:author',
          content: this.author
        },
        {
          property: 'article:published_time',
          content: this.lastUpdate
        },
        {
          property: 'og:title',
          content: this.title
        },
        {
          property: 'og:description',
          content: this.description
        },
        {
          property: 'og:image:secure_url',
          image: this.urlImg
        }
      ]
    }
  },
  data() {
    return {
      load: true,
      propertyHash: '',
      property: null,
      properties: [],
      title: '',
      description: '',
      image: '',
      author: '',
      lastUpdate: '',
      urlImg: '',
    }
  },
    computed: {
        ...mapGetters({
            path: 'path',
            operations: 'requests/operations',
            types: 'requests/types',
        }),
        customer() {
            const customer1 = this.property.branch.customer
            const customer2 = this.property.branch.name
            this.author = this.property.branch.name
            if (customer1 === customer2) {
                return customer1
            } else {
                return customer1 + ' | ' + customer2
            }
        },
        location() {
            let model = {
                boolean: false,
                data: [
                    { name: 'Calle', value: this.property.address },
                    { name: 'Localidad/Barrio', value: this.property.zone3 },
                    { name: 'Municipio', value: this.property.zone2 },
                    { name: 'Provincia', value: this.property.zone1 },
                ],
            }

            for (let i = 0; i < model.data.length; i++) {
                if (model.data[i].value !== undefined) {
                    model.boolean = true
                    break
                }
            }

            return model
        },
        features() {
            let model = {
                boolean: false,
                data: [
                    { name: 'Amoblado', value: this.property.furnished },
                    // { name: 'Estado', value: this.property.status },
                    { name: 'Apto profesional', value: this.property.professional },
                    { name: 'Año/s de antigüedad', value: this.property.yearsOld },
                    { name: 'Superficie cubierta', value: this.property.buildArea },
                    { name: 'Superficie total', value: this.property.landArea },
                    { name: 'Dormitorio/s', value: this.property.rooms },
                    { name: 'Ambientes / Espacios', value: this.property.ambiences },
                    { name: 'Dormitorio en suite', value: this.property.suite },
                    { name: 'Cuarto/s de servicio', value: this.property.dependencies },
                    { name: 'Playroom', value: this.property.playroom },
                    { name: 'Comedor diario', value: this.property.dailyDinning },
                    { name: 'Baño/s completo/s', value: this.property.bathrooms },
                    { name: 'Toilette/s', value: this.property.toilettes },
                    { name: 'Comedor diario', value: this.property.laundry },
                    { name: 'Balcón tipo', value: this.property.balcony },
                    { name: 'Jardín al frente', value: this.property.frontGarden },
                    { name: 'Patio', value: this.property.patio },
                    { name: 'Terraza', value: this.property.terrace },
                    { name: 'Departamentos por piso', value: this.property.apartmentsPerFloor },
                    { name: 'Plantas', value: this.property.floors },
                    { name: 'Edificio pisos', value: this.property.totalFloors },
                    { name: 'Ubicación', value: this.property.ubication },
                    { name: 'Orientación', value: this.property.orientation },
                    { name: 'Calefacción', value: this.property.heatingType },
                    { name: 'Aire acondicionado', value: this.property.airConditionerType },
                    { name: 'Agua caliente', value: this.property.waterHeaterType },
                    { name: 'Vigilancia/Seguridad', value: this.property.security },
                    { name: 'Alarma de seguridad', value: this.property.alarm },
                    { name: 'Caja de seguridad', value: this.property.securityBox },
                    { name: 'Encargado/Portero', value: this.property.janitor },
                    { name: 'Baulera/Guarda objetos', value: this.property.storage },
                    { name: 'Ascensor privado', value: this.property.privateElevator },
                    { name: 'Parrilla', value: this.property.grill },
                    { name: 'Televisión por cable', value: this.property.cable },
                    { name: 'Salón de Fiestas', value: this.property.sum },
                    { name: 'Línea telefónica', value: this.property.phoneLine },
                    { name: 'Piscina', value: this.property.swimmingPool },
                    { name: 'Tipo de garage', value: this.property.garageType },
                ],
            }

            for (let i = 0; i < model.data.length; i++) {
                if (model.data[i].value !== undefined) {
                    model.boolean = true
                    break
                }
            }

            return model
        },
        surfaces() {
            let model = {
                boolean: false,
                data: [
                    { name: 'Living', value: this.property.livingSize },
                    { name: 'Cocina', value: this.property.kitchenSize },
                    { name: 'Habitación 1', value: this.property.room1Size },
                    { name: 'Habitación 2', value: this.property.room2Size },
                    { name: 'Habitación 3', value: this.property.room3Size },
                    { name: 'Habitación 4', value: this.property.room4Size },
                    { name: 'Dependencia 1', value: this.property.dependency1Size },
                    { name: 'Dependencia 2', value: this.property.dependency2Size },
                    { name: 'Baño 1', value: this.property.bathroom1Size },
                    { name: 'Baño 2', value: this.property.bathroom2Size },
                    { name: 'Toilette 1', value: this.property.toilette1Size },
                    { name: 'Toilette 2', value: this.property.toilette2Size },
                    { name: 'Patio', value: this.property.patioSize },
                    { name: 'Balcón', value: this.property.balconySize },
                ],
            }

            for (let i = 0; i < model.data.length; i++) {
                if (model.data[i].value !== undefined) {
                    model.boolean = true
                    break
                }
            }

            return model
        },
    },
    watch: {
        $route(to, from) {
            this.load = true
            this.property = null
            this.properties = null
            if (Object.keys(this.$route.params).length > 0) {
                const params = this.$route.params.pathMatch.split('/')
                this.propertyHash = params[1]
                this.GETproperty()
            }
        },
    },
    methods: {
        titleProperty(property) {
            let title = ''
            let by = ''
            let and = ''
            let bathrooms = ''
            let bedrooms = ''

            const operation = this.operations.filter((elem) => elem.key.includes(property.operation))[0]
            const type = this.types.filter((elem) => elem.key.includes(property.type))[0]

            if (property.bedrooms !== undefined) {
                if (property.bedrooms == 1) {
                    bedrooms = `${property.bedrooms} dormitorio`
                } else {
                    bedrooms = `${property.bedrooms} dormitorios`
                }
            }

            if (property.bathrooms !== undefined) {
                if (property.bathrooms == 1) {
                    bathrooms = `${property.bathrooms} baño`
                } else {
                    bathrooms = `${property.bathrooms} baños`
                }
            }

            if (bathrooms.length > 0 || bedrooms.length > 0) {
                by = 'con'
            }

            if (bathrooms.length > 0 && bedrooms.length > 0) {
                and = 'y'
            }

            // title = `${operation.value} de ${type.value} en ${property.zone3Desc !== undefined ? property.zone3Desc : property.zone2Desc}, ${property.zone1Desc} ${by} ${bedrooms} ${and} ${bathrooms} | ${property.price} ${property.currency}`
            title = `${operation.value} de ${type.value} en ${
                property.zone3Desc !== undefined ? property.zone3Desc : property.zone2Desc
            }, ${property.zone1Desc} ${by} ${bedrooms} ${and} ${bathrooms}`

            return title
        },
        operation(operation) {
            const country = this.path.split('/')[1].toLowerCase()

            let result = ''

            operationNames[country].forEach((out, inx) => {
                if (out.value === operation) {
                    result = out.text
                }
            })

            return result
        },
        type(type) {
            const result = this.types.filter((elem) => elem.key.includes(type))[0]

            return result.value
        },
        async GETproperty() {
            try {
                const { data } = await property(this.propertyHash)

                this.property = data
                propertyHit(data.customerId, data.propertyId, window.location.href)
                this.description = this.property.description.substring(0, 74)
                setTimeout(() => {
                    this.GETproperties()
                }, 500)
            } catch (error) {
                console.log(error)
                this.property = { error: 'Propiedad no encontrada' }
                this.load = false
            }
        },
        async GETproperties() {
            try {
                const { data } = await properties({
                    stateId: this.property.zone1,
                    countyId: this.property.zone2,
                    cityId: this.property.zone3,
                })

                this.properties = data.properties
                this.load = false
                this.saveLocalStorage()
            } catch (error) {
                console.log(error)
            }
        },
        saveLocalStorage() {
            const codeCountry = this.$route.params.country

            this.$store.dispatch('local/historiesViewAction', {
                country: codeCountry,
                currency: this.property.currency,
                image: this.property.images[0].image,
                name: this.property.title,
                operation: this.property.operation,
                price: this.property.price,
                url: this.$route.path,
            })
            this.url = this.$route.path
            this.image = this.property.images[0].image
            this.title = this.property.title
            this.lastUpdate = this.property.lastUpdateFormated
            this.urlImg = `${vSlider.data().url}${this.image}`
        },
        changeTab(event, name) {
            const tabcontents = this.$el.querySelectorAll('.tabcontent')
            tabcontents.forEach((content) => {
                content.classList.remove('active')
            })
            const tablinks = this.$el.querySelectorAll('.tablinks')
            tablinks.forEach((link) => {
                link.classList.remove('active')
            })
            this.$refs[name].classList.add('active')
            event.target.classList.add('active')

            // document.head.querySelector('metaInfo[name="description"]').content = _desc
        },
    },
    created() {
        if (Object.keys(this.$route.params).length > 0) {
            const params = this.$route.params.pathMatch.split('/')
            this.propertyHash = params[1]
            this.GETproperty()
        }
    },
}
</script>

<style lang="scss">
.property {
    &__loader {
        padding-top: 2rem;
        padding-bottom: 2rem;
    }
    &__error {
        margin-top: 2rem;
        text-align: center;
    }
    &__aside {
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: 1fr;
    }
    &__customer {
        > h3 {
            margin-bottom: 1rem;
            font-weight: 700;
            font-size: 1.2rem;
        }
        > img {
            width: 100%;
            margin-bottom: 1rem;
        }
    }
    &__header {
        min-height: 60px;
        padding: 0.5rem 1rem;
        display: flex;
        align-items: center;
        // display: grid;
        // grid-gap: 1rem;
        // grid-template-columns: 1fr auto;
        // align-items: center;
        border-bottom: 1px solid #e3e3e3;
        justify-content: space-between;
        h1 {
            font-weight: 600;
            font-size: 1.4rem;
        }
        h2 {
            width: 70%;
            // font-weight: 600;
            font-size: 1.1rem;
        }
        span {
            white-space: nowrap;
            font-weight: 600;
            font-size: 1.2rem;
            color: #c9d700;
        }
    }
    &__information {
        padding: 1rem;
        border-bottom: 1px solid #e3e3e3;
        > h3 {
            margin-bottom: 1.5rem;
            font-weight: 700;
            font-size: 1.2rem;
        }
        > p {
            text-align: justify;
            font-size: 0.9rem;
            color: #555555;
        }
    }
    &__head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e3e3e3;
        margin-bottom: 1rem;
        &__price {
            // width: 50%;
            margin-bottom: 0.5rem;
            display: block;
            // font-weight: 600;
            color: #000000;
            font-size: 1.3rem;
            display: flex;
        }
        &__title {
            width: 70%;
            margin-bottom: 0.5rem;
            display: block;
            font-weight: 600;
            color: #000000;
            font-size: 1rem;
        }
    }

    &__detail {
        margin-bottom: 1rem;
        padding: 0.5rem;
        display: grid;
        grid-gap: 0 1rem;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid #e3e3e3;
        border-radius: 4px;
        background-color: #f3f3f3;
        span {
            margin-bottom: 0.2rem;
            display: block;
            font-size: 0.8rem;

            b {
                font-weight: 600;
                font-size: 0.8rem;
            }

            &.span-2 {
                grid-column: span 2;
                margin-top: 0.5rem;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
        &:last-child {
            margin-bottom: 0;
        }

        &--size {
            span {
                font-size: 0.8rem;
            }
        }
    }

    &__actions {
        display: flex;
        flex-wrap: wrap;
        button {
            width: max-content;
            margin-bottom: 1rem;
            padding-left: 1rem;
            padding-right: 1rem;
            align-items: center;
            border-radius: 4px;

            &:nth-of-type(1) {
                margin-right: 1rem;
            }

            &:nth-of-type(2) {
                background-color: #c9d700;
                svg {
                    fill: #ffffff;
                }
                span {
                    color: #ffffff;
                }
            }

            svg {
                height: 20px;
                width: 20px;
                margin-right: 1rem;
            }
        }
    }
    &__whatsapp {
        position: fixed;
        width: 4rem;
        height: 4rem;
        right: 2rem !important;
        bottom: 2rem !important;
        background-color: #25d366;
        color: #fff;
        border-radius: 50%;
        text-align: center;
        font-size: 30px;
        box-shadow: 0.1rem 0.1rem 0.3rem #999;
        z-index: 100;
        &__icon {
            width: 1.5rem;
            height: 1.5rem;
            margin-top: 0rem;
        }
    }
    &__properties {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        &__empty {
            padding: 0 1rem;
            text-align: center;
        }
        &__item {
            padding: 0.5rem 1rem;
            display: grid;
            grid-gap: 1rem;
            grid-template-columns: 140px 1fr;
            transition: all 0.4s;
            &:hover {
                background-color: #f3f3f3;
            }
        }
        &__image {
            height: 100px;
            width: 100%;
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }
        &__caption {
            h3 {
                margin-bottom: 0.5rem;
                font-weight: 600;
            }
            span {
                color: #c9d700;
            }
        }
    }
    @media (max-width: 992px) {
        &__header {
            grid-template-columns: 1fr;
            h1 {
                text-align: center;
                font-size: 1.2rem;
            }
            span {
                text-align: center;
            }
        }
    }
    @media (max-width: 576px) {
        &__detail {
            grid-template-columns: 1fr;
            span {
                &.span-2 {
                    grid-column: span 1;
                }
            }
        }
    }
}

/* Style the tab */
.tab {
    overflow: hidden;
    // border: 1px solid #ccc;
    border-radius:0;
    background-color: #f1f1f1;
    margin-top: 0;
    margin-bottom: 0;
    button {
        background-color: inherit;
        float: left;
        border: none;
        outline: none;
        cursor: pointer;
        padding: 14px 16px;
        transition: 0.3s;
        width:auto;
        &:hover {
            // background-color: #c9d700;
            // color: #fff;
            font-weight: bold;
        }
        &.active {
            background-color: #c9d700;
            color: #fff;
            font-weight: bold;
        }
    }
}
/* Style the tab content */
.tabcontent {
    display: none;
    animation: fadeEffect 1s; /* Fading effect takes 1 second */
    &.active {
        display: block;
    }
}
/* Go from zero to full opacity */
@keyframes fadeEffect {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>
